import { Injectable, NgZone } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController, ToastController, ActionSheetController, LoadingController, AlertController, PopoverController } from '@ionic/angular';
import { Platform } from '@ionic/angular';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { HttpService } from './http.service';
import { GlobalService } from './global.service';
import { PickerController } from '@ionic/angular';
import domtoimage from 'dom-to-image';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
// import { PhotoViewer } from '@awesome-cordova-plugins/photo-viewer/ngx';
// import { NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels } from '@techiediaries/ngx-qrcode';
import * as moment from 'moment';
// import { AngularFireAuth } from '@angular/fire/auth';
// import firebase from 'firebase';
// import { GooglePlus } from '@ionic-native/google-plus/ngx';

// import { ViewerModalComponent } from 'ngx-ionic-image-viewer';

@Injectable({
  providedIn: 'root'
})
export class PageService {
  loading: any;
  moduleName = '';
  // qrElementType = NgxQrcodeElementTypes.URL;
  // qrCorrectionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;
  hideMenu: Boolean = false;
  

  constructor(
    public activatedRoute: ActivatedRoute,
    public modalCtrl: ModalController,
    public geolocation: Geolocation,
    public camera: Camera,
    public loadingController: LoadingController,
    public actionSheetController: ActionSheetController,
    public platform: Platform,
    public global: GlobalService,
    public httpService: HttpService,
    public location: Location,
    public router: Router,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
    public popoverController: PopoverController,
    public zone: NgZone,
    public pickerCtrl: PickerController,
    public socialSharing: SocialSharing,
    // public photoViewer: PhotoViewer,
    // public viewerModalComponent: ViewerModalComponent, 
    // public fireAuth: AngularFireAuth,
    // public google: GooglePlus
  ) {
  }


  // (+) Navigation

  navigate(endPoint = '') {
    //this.router.navigate(['/' + this.getModuleName() + endPoint]);
    this.navigateRoute('/' + this.getModuleName() + endPoint);
  }

  navigateRoute(route,extra = {}) {
    this.router.navigate([route],extra);
  }

  navigateReplace(url, params = {}) {
    this.router.navigate([url, params], {skipLocationChange: true, replaceUrl: false});
  }

 

  navigateBack() {
    this.location.back();
  }

  backToHome() {
    window.history.go((window.history.length - 1) * -1);
  }

  // (-) Navigation

  // (+) Module name

  getModuleName() {
    return this.location.path().split('/')[1];
  }

  // (-) Module name

  // (+) Http

  getHttpEndPoint() {
    return '/' + this.getModuleName();
  }

  httpGetAll( endPoint, showLoading = true, sort:any = { name: 1 } , filters:any = {}, populates:any = [], page:any = -1) {
    return this.httpService.getAll( endPoint, filters, showLoading, sort, populates, page );
  }

  httpRemove( endPoint, item ) {
    return this.httpService.remove( endPoint, item );
  }

  httpCreate( endPoint, item ) {
    return this.httpService.create( endPoint, item );
  }

  httpUpdate( endPoint, item  ) {
    return this.httpService.update( endPoint, item );
  }

  httpGetById( endPoint, id, showLoading = true, populates:any = [] ) {
    return this.httpService.getById( endPoint, id, showLoading, populates );
  }

  httpPut( endPoint, values ) {
    return this.httpService.put( endPoint, values );
  }

  httpPost( endPoint, values ) {
    return this.httpService.post( endPoint, values );
  }

  httpDelete( endPoint ) {
    return this.httpService.delete( endPoint );
  }

  httpPatch( endPoint, values ) {
    return this.httpService.patch( endPoint, values );
  }

  httpGet(endPoint) {
    return this.httpService.get(endPoint);
  }

  httpPostFile( fileName ) {
    return this.httpService.postFile( fileName );
  }

  httpPostFileBase64( file, resolve, reject) {
    return this.httpService.postFileBase64( file, resolve, reject );
  }

  // (-) Http

  getMessage(message) {
    let msg = message;
    if(message.message) msg = message.message;
    return msg;
  }

  // (+) Show messages

  showSuccess(message) {
    this.showMessage(message,"toast-success");
  }
  showError(message) {
    this.showMessage(message,"toast-error");
  }
  showWarning(message) {
    this.showMessage(message,"toast-warning");
  }
  showMessage(message,cssClass){

    // if(message.error && message.error == 404) return;

    let msg = message.message || message;
    let toast = this.toastCtrl.create({
      message: msg,
      cssClass:cssClass,
      duration: 2000,
      position: 'top'
    }).then((toastData)=>{
      toastData.present();
    });

  }

  // (-) Show messages

  auth(path): boolean {
    // for (let routeKey in this.global.settings.routes) {
    //   let route = this.global.settings.routes[routeKey];
    //   if(path == ('/' + route.path)) {
    //     if(route.data && route.data.roles) {
    //       const user = this.global.getUser();
    //       if( user ) {
    //         const userRoles = [...user.roles || []];
    //         if(!route.data.roles.some(r=> userRoles.includes(r))) {
    //           return false;
    //         } else {
    //           return true;
    //         }
    //       }
    //     }
    //     return true;
    //   }
    // }
    return true;
  }


  // (+) Image

  showImageUpload(params?: any): Promise<any> {
    return new Promise(async (resolve, reject) => {
      let actionSheet = await this.actionSheetController.create({
        header: "¿Como desea cargar su imagen?'",
        buttons: [{
          text:   "Galería",
          handler: () => {
            this.showImageUploadTake('gallery', resolve, reject);
          }
        }, {
          text: "Cámara",
          handler: () => {
            this.showImageUploadTake('camera', resolve, reject);
          }
        }, {
          text: "Cancelar",
          role: 'cancel',
          handler: () => {
            resolve(null);
          }
        }]
      });
      await actionSheet.present();
    });
  }

  showImageUploadTake(source, resolve, reject) {
    if (!this.platform.is('cordova')) {
      let element = document.createElement('input');
      element.type = 'file';
      element.accept = 'image/*';
      element.onchange = () => {
        this.httpPostFile(element.files[0])
          .then((result) => {
            resolve(result);
          })
          .catch((error) => {
            reject(error);
          });
      };
      element.click();
    } else {
      let cameraOptions: CameraOptions = {
        quality: 85,
        destinationType: this.camera.DestinationType.DATA_URL,
        encodingType: this.camera.EncodingType.JPEG,
        mediaType: this.camera.MediaType.PICTURE,
        sourceType: source == 'gallery' ? this.camera.PictureSourceType.PHOTOLIBRARY : this.camera.PictureSourceType.CAMERA,
        correctOrientation: true,
        // allowEdit: true
      };
      this.camera.getPicture(cameraOptions).then((file) => {
        this.httpPostFileBase64(file, resolve, reject);
      }, (error) => {
        reject(error);
      });
    }
  }

  // (-) Image


  // (+) Loading

  // (+) Loading
  async showLoading(content = 'Procesando...'){
    // this.loading = await this.loadingController.create({
    //   message: content
    // });
    // await this.loading.present();
    this.global.showLoading();
  }

  async hideLoading(){
    this.global.hideLoading();
    // if(this.loading) await this.loading.dismiss();
  }
  // (-) Loading

  // async showLoading(content = 'Procesando...'){
  //   this.loading = await this.loadingController.create({
  //     message: content
  //   });
  //   await this.loading.present();
  //   this.global.showLoading();
  //   console.log("LOADDD");
  // }

  // async hideLoading(){
  //   this.global.hideLoading();
  //   if(this.loading) await this.loading.dismiss();
  //   console.log("loading ",this.loading);
  //   console.log("HIDEEEEE");
  // }
  // (-) Loading

  // (+) Map

  loadGoogleMapsLibrary(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (window['google']) {
        return resolve(window['google']);
      }
      let element = document.createElement('script');
      element.id = 'google-maps-api-script';
      element.src = 'https://maps.googleapis.com/maps/api/js?key=' + this.global.settings.keys.googleMaps + '&libraries=places';
      element.type = 'text/javascript';
      element.onload = () => {
        resolve(window['google']);
      };
      element.onerror = (error) => {
        reject();
      }
      document.body.appendChild(element);
    });
  }

  getCurrentLocation() {
    return new Promise( (resolve, reject) => {
      this.geolocation.getCurrentPosition().then((position) => { 
        const pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
       resolve(pos);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  // (-) Map

  // (+) Push
  // enablePN(user) {
  //   this.user = user
  //   this.push.hasPermission()
  //     .then((res: any) => {
  //       if (res.isEnabled) {
  //         console.log('We have permission to send push notifications');
  //         this.registerPN();
  //       } else {
  //         console.log('We do not have permission to send push notifications');
  //         this.registerPN();
  //       }
  //     })
  //     .catch(response => {
  //       console.log(response);
  //       alert(response);
  //     });
  // }
  //
  // registerPN() {
  //   const options: PushOptions = {
  //     android: {
  //       icon: this.settings.push.icon.name,
  //       iconColor: this.settings.push.icon.color
  //     },
  //     ios: {
  //       alert: 'true',
  //       badge: true,
  //       sound: 'false'
  //     },
  //     windows: {},
  //     browser: {
  //       pushServiceURL: 'http://push.api.phonegap.com/v1/push'
  //     }
  //   };
  //
  //   const pushObject: PushObject = this.push.init(options);
  //
  //
  //   pushObject.on('notification').subscribe((notification: any) => {
  //     console.log('Received a notification:' + JSON.stringify(notification));
  //     this.events.publish(this.settings.push.events.onNotification,notification);
  //   });
  //
  //   pushObject.on('registration').subscribe((registration: any) => {
  //     console.log('Device registered:' + JSON.stringify(registration));
  //
  //     let user = this.global.loadUser();
  //     user.pnId = registration.registrationId;
  //     user.app = this.settings.push.appId;
  //     if (this.platform.is('android')) {
  //       user.osType = 'android'
  //     } else if (this.platform.is('ios')) {
  //       user.osType = 'ios'
  //     }
  //
  //     // const url = "http://190.106.134.143:3050/api/users/ensure"; //Micam
  //     const url = Constants.PUSH_SERVER_URL + Constants.PUSH_SERVER_REGISTER_ID;
  //
  //
  //     console.log("Ensure:" + JSON.stringify(this.user));
  //     //alert("Ensure:" + JSON.stringify(this.user));
  //
  //     this.http.post(url, this.user)
  //       .toPromise()
  //       .then(response => {
  //         console.log("Ensure OK:" + JSON.stringify(response));
  //         //alert("Ensure OK :" + JSON.stringify(response));
  //       })
  //       .catch(error => {
  //         console.log("Error:" + JSON.stringify(error));
  //         //alert("Error:" + JSON.stringify(error));
  //       });
  //
  //   }
  //   );
  //
  //   pushObject.on('error').subscribe(error => alert('Ha ocurrido un error con el servidor de push notification ' + error));
  //
  // }
  // (-) Push

  //(+) Qr

  setStyleQrCode(){
    let qrcodeContainer: any = document.getElementsByClassName("qrcode")[0];
    let imgQrcodeContainer: any = qrcodeContainer.getElementsByTagName("img")[0];
    qrcodeContainer.style.display = "flex";
    qrcodeContainer.style.justifyContent = "center";
    qrcodeContainer.style.width = "100%";
    qrcodeContainer.style.height = "100%";
    imgQrcodeContainer.style.minWidth = "100%"
  }

  //(-) Qr

  showTimeLapsed(date: Date, fromParamDate: Boolean) {
    let today = moment();
    let paramDate = moment(date);
    let timeLapsed;
    if (fromParamDate) timeLapsed = paramDate.diff(today);
    else timeLapsed = today.diff(paramDate);

    let parts = [];
    const duration = moment.duration(timeLapsed);

    if (!duration || duration.toISOString() === 'P0D') return 'Ha ocurrido un error';

    if (duration.years() >= 1) {
      const years = Math.floor(duration.years());
      parts.push(years + ' ' + (years > 1 ? 'años' : 'año'));
    }

    if (duration.months() >= 1) {
      const months = Math.floor(duration.months());
      parts.push(months + ' ' + (months > 1 ? 'meses' : 'mes'));
    }

    if (duration.days() >= 1) {
      const days = Math.floor(duration.days());
      parts.push(days + ' ' + (days > 1 ? 'dias' : 'dia'));
    }

    if (duration.hours() >= 1) {
      const hours = Math.floor(duration.hours());
      parts.push(hours + ' ' + (hours > 1 ? 'horas' : 'hora'));
    }

    if (duration.minutes() >= 1) {
      const minutes = Math.floor(duration.minutes());
      parts.push(minutes + ' ' + (minutes > 1 ? 'minutos' : 'minuto'));
    }

    if (duration.seconds() >= 1 && parts.length == 0) {
      const seconds = Math.floor(duration.seconds());
      parts.push(seconds + ' ' + (seconds > 1 ? 'segundos' : 'segundo'));
    }

    return parts.join(' ');
  }

  share(id, params?: {message?: string, subject?: string, file?: string | string[], url?: string, other?: any}) {
    var node = document.querySelector(id);
    if (params && params.other && params.other.isHidden) node.style.display = 'flex';
    domtoimage.toPng(node)
    .then((dataUrl) => {

        if (params && params.other && params.other.isHidden) node.style.display = 'none';

        if (this.platform.is('cordova')) {
          this.socialSharing
            .share(params.message, params.subject, dataUrl)
            .then(res => {
            })
            .catch(err => {
              console.log('error share', err);
              this.showError(err);
            });
        } else {
          this.downloadBase64File(dataUrl, params.subject + '.png');
        }

      })
      .catch((error) => {
        if (params && params.other && params.other.isHidden) node.style.display = 'none';
        console.error('oops, something went wrong!', error);
        this.showError(error);
      });
  }

  
  downloadBase64File(base64Data, name) {
    const linkSource = base64Data;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = name;
    downloadLink.click();
}

  //(+) Social login

  // async loginGoogle() {

  //   if (this.platform.is('cordova')) {
  //     let params: any;
  //     if (this.platform.is('android')) {
  //       params = {
  //         webClientId: this.global.settings.firebase.webClientId,
  //         offline: true
  //       };
  //     } 
  //     else {
  //       params = {};
  //     }

  //     return await this.google.login(params).then( async (res) => {
  //       console.log('Good google plus login!', res);

  //       const idToken = res.idToken;
  //       const accessToken  = res.accessToken;

  //       const credential = accessToken ? firebase.auth.GoogleAuthProvider.credential(idToken, accessToken) : firebase.auth.GoogleAuthProvider.credential(idToken);
        
  //       return await this.fireAuth.signInWithCredential(credential).then( (res) => {
  //         console.log('Good fireauth signinwithcredential!', res)

  //         const result: any = {
  //           isNewUser: res.additionalUserInfo.isNewUser,
  //           firstName: res.additionalUserInfo.profile['given_name'],
  //           lastName: res.additionalUserInfo.profile['family_name'],
  //           emailAddress: res.additionalUserInfo.profile['email'],
  //           username: res.additionalUserInfo.profile['email'],
  //           picture: res.additionalUserInfo.profile['picture']
  //         };

  //         return result;
  //       });
        
  //     })
  //     .catch( (error) => {
  //       console.log('Bad', error);

  //       throw error;
  //     });

  //   }
  //   else {
  //     throw 'Plataforma no compatible';
  //     // this.fireAuth.signInWithPopup(new firebase.auth.GoogleAuthProvider()).then( (res) => {
  //     //   console.log('Good!', res);


  //     // })
  //     // .catch( (error) => {
  //     //   console.log('Bad', error);
  //     // });

  //   }

  // }


  // logoutSocial() {
  //   this.fireAuth.signOut().then( () => {
  //     console.log("signOut")
  //   })
  //   .catch( (error) => {
  //     console.log(error);
  //   });
  // }

  //(-) Social login

  logout() {
    this.global.removeUser();
  }

}
